import { APP_THEME_DARK, APP_THEME_LIGHT } from './theme-constants';

export const seedDefaultTheme = APP_THEME_LIGHT;
export const seedSupportedThemes = [APP_THEME_LIGHT, APP_THEME_DARK];
